import classNames from 'classnames';
import {
  connectRepriceQuoteButton,
  type RepriceQuoteButtonProps,
} from 'components/common-form/sidePanel/actions/quote/RepriceQuoteButton.connect';
import { useCrossBrowserContext } from 'hooks/useCrossBrowserContext';
import { FormattedMessage, useIntl } from 'react-intl';

function RepriceQuoteButtonRawNext({ isHidden, isFormDirty, onReprice }: RepriceQuoteButtonProps) {
  const { formatMessage } = useIntl();
  const { isDirty, isLocked } = useCrossBrowserContext();
  const isDisabled = isDirty || isLocked || isFormDirty;
  return isHidden ? null : (
    <button
      className={classNames('btn btn-lg btn-flat-primary-alt btn-icon')}
      type="button"
      title={formatMessage({ id: 'sidePanel.repriceQuote' })}
      onClick={onReprice}
      disabled={isDisabled}
    >
      <i className="icon">refresh</i>
      <span className="visually-hidden">
        <FormattedMessage id="sidePanel.repriceQuote" />
      </span>
    </button>
  );
}

export const RepriceQuoteButtonNext = connectRepriceQuoteButton(RepriceQuoteButtonRawNext);
